import { render } from "./TimeTable.vue?vue&type=template&id=95f2cd8e&scoped=true"
import script from "./TimeTable.vue?vue&type=script&lang=js"
export * from "./TimeTable.vue?vue&type=script&lang=js"

import "./TimeTable.vue?vue&type=style&index=0&id=95f2cd8e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95f2cd8e"]])

export default __exports__